/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/i18n'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },

  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '/',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: i18n.t('menu.dashboad.url'),
          name:i18n.t('menu.dashboad.name'),
          component: () => import('./views/Home2.vue'),
          meta: {
            // breadcrumb: i18n.t('menu.dashboad.meta.breadcrumb'),
            // pageTitle: i18n.t('menu.dashboad.meta.pageTitle'),
            rule: i18n.t('menu.dashboad.meta.rule')
          },
          beforeEnter (to, from, next) {
            const userRoles = JSON.parse(localStorage.getItem('userRoles'))
            if (userRoles && userRoles[0].name === 'user') {
              router.app.$nextTick(() => {
                router.app.$vs.loading.close()
              })
              if (process.env.VUE_APP_I18N_LOCALE === 'dogs') {
                next({path : '/contact/pets/cameras', replace: true})
              } else {
                next({path : '/user/students/cameras', replace: true})
              }
            } else if (userRoles && userRoles[0].name === 'blog') {
              next({path : '/blogs', replace: true})
            } else if (userRoles && userRoles[0].name === 'teacher') {
              next({path : '/dashboard', replace: true})
            } else {
              next()
            }
            
          }

        },
        {
          path: 'demo-requests',
          name: 'Demo Requests',
          component: () => import('./views/demo/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Demo Requests', active: true }
            ],
            pageTitle: 'Demo Requests',
            rule: 'admin'
          }
        },
        {
          path: 'aws-centers',
          name: 'AWS Centers',
          component: () => import('./views/aws-centers/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'AWS Centers', active: true }
            ],
            pageTitle: 'AWS Centers',
            rule: 'admin'
          }
        },
        {
          path: 'center/:centerId',
          name: 'Center Profile',
          component: () => import('./views/centers/CenterProfile.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Center', url: '/centers' },
              { title: 'Center View', active: true }
            ],
            pageTitle: 'Center View',
            rule: 'admin'
          }
        },
        {
          path: 'aws-center/:centerId',
          name: 'Center View',
          component: () => import('./views/aws-centers/CenterProfile.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'AWS Center', url: '/aws-centers' },
              { title: 'Center View', active: true }
            ],
            pageTitle: 'Center View',
            rule: 'admin'
          }
        },
        {
          path: 'main/tickets/:status?',
          name: 'Main Tickets',
          component: () => import('./views/main/tickets/ListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Tickets', active: true }
            ],
            pageTitle: 'Tickets',
            rule: 'kvsupport'
          }
        },
        {
          path: 'main/ticket/:ticketId',
          name:'Main Ticket Profile',
          component: () => import('@/views/main/tickets/Profile.vue'),
          meta: {
            breadcrumb:[
              {
                'title': 'Home',
                'url': '/'
              },
              {
                'title': 'Tickets',
                'url': '/main/tickets'
              },
              {
                'title': 'View',
                'active': true
              }
            ],
            pageTitle:'Ticket View',
            rule: 'kvsupport'
          }
        },
        {
          path:  'main/incidents',
          name:  'incidents',
          component: () => import('@/views/main/incidents/Incidents.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Incidents', active: true }
            ],
            pageTitle: 'Incidents',
            rule:  'kvsupport'
          }
        },
        {
          path: 'main/incident/:id',
          name: 'view-main-incident',
          component: () => import('@/views/main/incidents/ViewIncident.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Incidents', url:'/main/incidents' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Incident View',
            rule: 'kvsupport'
          }
        },
        {
          path: i18n.t('menu.students.url'),
          name: i18n.t('menu.students.name'),
          // component: () => import('@/views/students/StudentList2.vue'),
          component: () => import('@/views/students/DataListView.vue'),
          meta: {
            breadcrumb: i18n.t('menu.students.meta.breadcrumb'),
            pageTitle: i18n.t('menu.students.meta.pageTitle'),
            rule: i18n.t('menu.students.meta.rule')
          }
        },
        // {
        //   path: 'test-students',
        //   name: i18n.t('menu.students.name'),
        //   component: () => import('@/views/students/DataListView.vue'),
        //   meta: {
        //     breadcrumb: i18n.t('menu.students.meta.breadcrumb'),
        //     pageTitle: i18n.t('menu.students.meta.pageTitle'),
        //     rule: i18n.t('menu.students.meta.rule')
        //   }
        // },
        {
          path: i18n.t('menu.students_user.url'),
          name: i18n.t('menu.students_user.name'),
          component: () => import('@/views/user-students/DataListView.vue'),
          meta: {
            // breadcrumb: i18n.t('menu.students_user.meta.breadcrumb'),
            pageTitle: i18n.t('menu.students_user.meta.pageTitle'),
            rule: i18n.t('menu.students_user.meta.rule')
          }
        },
        {
          path: i18n.t('menu.students_teacher.url'),
          name: i18n.t('menu.students_teacher.name'),
          component: () => import('@/views/teacher-students/DataListView.vue'),
          meta: {
            breadcrumb: i18n.t('menu.students_teacher.meta.breadcrumb'),
            pageTitle: i18n.t('menu.students_teacher.meta.pageTitle'),
            rule: i18n.t('menu.students_teacher.meta.rule')
          }
        },
        {
          path:  i18n.t('menu.users.url'),
          name:  i18n.t('menu.users.name'),
          // component: () => import('@/views/cam-users/DataListView.vue'),
          component: () => import('@/views/cam-users/DataListView2.vue'),
          meta: {
            breadcrumb:  i18n.t('menu.users.meta.breadcrumb'),
            pageTitle:  i18n.t('menu.users.meta.pageTitle'),
            rule:  i18n.t('menu.users.meta.rule')
          }
        },
        // {
        //   path:  'users2',
        //   name:  i18n.t('menu.users.name'),
        //   // component: () => import('@/views/cam-users/DataListView.vue'),
        //   component: () => import('@/views/cam-users/DataListView.vue'),
        //   meta: {
        //     breadcrumb:  i18n.t('menu.users.meta.breadcrumb'),
        //     pageTitle:  i18n.t('menu.users.meta.pageTitle'),
        //     rule:  i18n.t('menu.users.meta.rule')
        //   }
        // },
        // {
        //   path:  'test-users',
        //   name:  i18n.t('menu.users.name'),
        //   component: () => import('@/views/cam-users/DataListView2.vue'),
        //   meta: {
        //     breadcrumb:  i18n.t('menu.users.meta.breadcrumb'),
        //     pageTitle:  i18n.t('menu.users.meta.pageTitle'),
        //     rule:  i18n.t('menu.users.meta.rule')
        //   }
        // },
        {
          path:  i18n.t('menu.incidents.url'),
          name:  i18n.t('menu.incidents.name'),
          component: () => import('@/views/incidents/Incidents.vue'),
          meta: {
            breadcrumb:  i18n.t('menu.incidents.meta.breadcrumb'),
            pageTitle:  i18n.t('menu.incidents.meta.pageTitle'),
            rule:  i18n.t('menu.incidents.meta.rule')
          }
        },
        {
          path: '/centers',
          name: 'centers',
          component: () => import('@/views/centers/DataListListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Centers', active: true }
            ],
            pageTitle: 'Centers',
            rule: 'kvsupport'
          }
        },
       
        {
          path: '/tickets/:status?',
          name: 'Tickets',
          component: () => import('./views/tickets/ListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Tickets', active: true }
            ],
            pageTitle: 'Tickets',
            rule: 'manager'
          }
        },
        {
          path: '/ticket/:ticketId',
          name:'Ticket Profile',
          component: () => import('@/views/tickets/Profile.vue'),
          meta: {
            breadcrumb:[
              {
                'title': 'Home',
                'url': '/'
              },
              {
                'title': 'Tickets',
                'url': '/tickets'
              },
              {
                'title': 'View',
                'active': true
              }
            ],
            pageTitle:'Ticket View',
            rule: 'manager'
          }
        },
        {
          path: '/locations',
          name: 'Locations',
          component: () => import('./views/locations/ListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Locations', active: true }
            ],
            pageTitle: 'Locations',
            rule: 'kvsupport'
          }
        },
        {
          path: '/location/:locationId',
          name: 'Location Profile',
          component: () => import('@/views/locations/locationView.vue'),
          meta: {
            breadcrumb:[
              {
                'title': 'Home',
                'url': '/'
              },
              {
                'title': 'All Locations',
                'url': '/locations'
              },
              {
                'title': 'View',
                'active': true
              }
            ],
            pageTitle: 'Location View',
            rule: 'kvsupport',
            parent:'/location'
          },
          children: [
            {
              path: 'rooms',
              name: 'location-rooms',
              component: () => import('@/views/rooms/LocationProgramsListView.vue'),
              meta: {
                breadcrumb:[
                  {
                    'title': 'Home',
                    'url': '/'
                  },
                  {
                    'title': 'All Locations',
                    'url': '/locations'
                  },
                  {
                    'title': 'View',
                    'active': true
                  }
                ],
                pageTitle: 'Location View',
                rule: 'kvsupport',
                parent:'rooms'
              } 
            },
            {
              path: 'programs',
              name: 'location-programs',
              component: () => import('@/views/billing_programs/LocationProgramsListView.vue'),
              meta: {
                breadcrumb:[
                  {
                    'title': 'Home',
                    'url': '/'
                  },
                  {
                    'title': 'All Locations',
                    'url': '/locations'
                  },
                  {
                    'title': 'View',
                    'active': true
                  }
                ],
                pageTitle: 'Location View',
                rule: 'kvsupport',
                parent:'programs'
              } 
            },
            {
              path: 'cameras',
              name: 'location-cameras',
              component: () => import('@/views/cameras/LocationCamerasListView.vue'),
              meta: {
                breadcrumb:[
                  {
                    'title': 'Home',
                    'url': '/'
                  },
                  {
                    'title': 'All Locations',
                    'url': '/locations'
                  },
                  {
                    'title': 'View',
                    'active': true
                  }
                ],
                pageTitle: 'Location View',
                rule: 'kvsupport',
                parent:'cameras'
              } 
            },
            {
              path: 'managers',
              name: 'location-managers',
              component: () => import('@/views/locations/locationView.vue'),
              meta: {
                breadcrumb:[
                  {
                    'title': 'Home',
                    'url': '/'
                  },
                  {
                    'title': 'All Locations',
                    'url': '/locations'
                  },
                  {
                    'title': 'View',
                    'active': true
                  }
                ],
                pageTitle: 'Location View',
                rule: 'kvsupport',
                parent:'/location'
              } 
            },
            {
              path: 'camera-groups',
              name: 'location-camera-groups',
              component: () => import('@/views/locations/locationView.vue'),
              meta: {
                breadcrumb:[
                  {
                    'title': 'Home',
                    'url': '/'
                  },
                  {
                    'title': 'All Locations',
                    'url': '/locations'
                  },
                  {
                    'title': 'View',
                    'active': true
                  }
                ],
                pageTitle: 'Location View',
                rule: 'kvsupport',
                parent:'cameras'
              } 
            },
            {
              path: 'settings',
              name: 'location-settings',
              component: () => import('@/views/locations/locationView.vue'),
              meta: {
                breadcrumb:[
                  {
                    'title': 'Home',
                    'url': '/'
                  },
                  {
                    'title': 'All Locations',
                    'url': '/locations'
                  },
                  {
                    'title': 'View',
                    'active': true
                  }
                ],
                parent:'/location',
                pageTitle: 'Location View',
                rule: 'kvsupport'
               
              } 
            }
            
             
          ] 
        },
        // {
        //   path: '/managerlocations',
        //   name: 'Locations',
        //   component: () => import('./views/locations/managerLocation.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: 'Locations', active: true }
        //     ],
        //     pageTitle: 'Locations',
        //     rule: 'manager'
        //   }
        // },
        // {
        //   path: '/locations/:locationId',
        //   name:'Location Profile',
        //   component: () => import('@/views/locations/profile.vue'),
        //   meta: {
        //     breadcrumb:[
        //       {
        //         'title': 'Home',
        //         'url': '/'
        //       },
        //       {
        //         'title': 'All Locations',
        //         'url': '/locations'
        //       },
        //       {
        //         'title': 'View',
        //         'active': true
        //       }
        //     ],
        //     pageTitle:'Location View',
        //     parent:'/location',
        //     rule: 'kvsupport'
        //   }
        // },
        {
          path: '/rooms/:action?',
          name: 'Rooms',
          component: () => import('./views/rooms/programsListView'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Rooms', active: true }
            ],
            pageTitle: 'Rooms',
            rule: 'manager'
          }
        },
        {
          path: '/billing_programs',
          name: 'billing_programs',
          component: () => import('./views/billing_programs/programsListView'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Programs', active: true }
            ],
            pageTitle: 'Programs',
            rule: 'manager'
          }
        },
        {
          path: '/cameras',
          name: 'Cameras',
          component: () => import('./views/cameras/ListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Cameras', active: true }
            ],
            pageTitle: 'Cameras',
            rule: 'manager'
          }

        },
        {
          path: '/schedules',
          name: 'Schedules',
          component: () => import('./views/schedules/ListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Camera Schedules', active: true }
            ],
            pageTitle: 'Camera Schedules',
            rule: 'manager'
          }
        },
        {
          path: '/student-tags',
          name: 'Tags',
          component: () => import('./views/student-tags/DataListTag.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Tags', active: true }
            ],
            pageTitle: 'Tags',
            rule: 'manager'
          }
        },
        {
          path: '/student-allergies',
          name: 'Allergies',
          component: () => import('./views/student-allergies/DataListAllergies.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Allergies', active: true }
            ],
            pageTitle: 'Allergies',
            rule: 'manager'
          }
        },
        {
          path: '/student-medications',
          name: 'Medications',
          component: () => import('./views/student-medications/DataListMedications.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Medications', active: true }
            ],
            pageTitle: 'Medications',
            rule: 'manager'
          }
        },
        {
          path: '/theme-customizer',
          name: 'Theme Customizer',
          component: () => import('./views/Settings/ThemeCustomizer'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Theme Customizer', active: true }
            ],
            pageTitle: 'Theme Customizer',
            rule: 'admin'
          }
        },
        {
          path: '/onboarding',
          name: 'Onboarding',
          component: () => import('./views/Settings/OnBoarding'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Utilities', url: '/utilities' },
              { title: 'Onboarding', active: true }
            ],
            pageTitle: 'Onboarding',
            rule: 'kvsupport',
            parent:'utilities'
          }
        },
        {
          path: '/utilities',
          name: 'Utilities',
          component: () => import('./views/Settings/Utilities'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Utilities', active: true }
            ],
            pageTitle: 'Utilities',
            rule: 'kvsupport'
          }
        },
        {
          path: '/advance-onboarding',
          name: 'Advance Onboarding',
          component: () => import('./views/Settings/AdOnBoarding'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Utilities', url: '/utilities' },
              { title: 'Advance Onboarding', active: true }
            ],
            pageTitle: 'Advance Onboarding',
            rule: 'kvsupport',
            parent:'utilities'
          }
        },
        {
          path: '/sync-brightwheel',
          name: 'Sync Brightwheel',
          component: () => import('./views/Settings/SyncBrightwheel'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Utilities', url: '/utilities' },
              { title: 'Sync Brightwheel', active: true }
            ],
            pageTitle: 'Sync Brightwheel',
            rule: 'kvsupport',
            parent:'utilities'
          }
        },
        {
          path: '/procare-import',
          name: 'Procare Desktop Import Students',
          component: () => import('./views/Settings/ProcareImport'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Utilities', url: '/utilities' },
              { title: 'Procare Desktop Import', active: true }
            ],
            pageTitle: 'Procare Desktop Import',
            rule: 'kvsupport',
            parent:'utilities'
          }
        },
        {
          path: '/procare-import-staff',
          name: 'Procare Desktop Import Staff',
          component: () => import('./views/Settings/ProcareImportStaff'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Utilities', url: '/utilities' },
              { title: 'Procare Desktop Import Staff', active: true }
            ],
            pageTitle: 'Procare Desktop Import Staff',
            rule: 'kvsupport',
            parent:'utilities'
          }
        },
        {
          path: '/send-custom-email',
          name: 'Send Email',
          component: () => import('./views/Settings/UtilityCustomEmail'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Utilities', url: '/utilities' },
              { title: 'Send Email', active: true }
            ],
            pageTitle: 'Send Email',
            rule: 'kvsupport',
            parent:'utilities'
          }
        },
        {
          path: '/import-cameras',
          name: 'Import Cameras',
          component: () => import('./views/Settings/UtilityImportCameras'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Utilities', url: '/utilities' },
              { title: 'Import Cameras', active: true }
            ],
            pageTitle: 'Import Cameras',
            rule: 'kvsupport',
            parent:'utilities'
          }
        },
        {
          path: '/school_profile',
          name: 'School Profile',
          component: () => import('./views/Settings/School'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'School Profile', active: true }
            ],
            pageTitle: 'School Profile',
            rule: 'manager'
          }
        },
    
        {
          path: '/images',
          name: 'Images',
          component: () => import('./views/images/imagesListView'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Images', active: true }
            ],
            pageTitle: 'Images',
            rule: 'manager'
          }
        },
        {
          path: '/folder/:folder',
          name: 'folder',
          component: () => import('./views/images/FolderImageView'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Images', url: '/images' },
              { title: 'Folder', active: true }
            ],
            pageTitle: 'Images',
            rule: 'admin'
          }
        },
        {
          path: '/announcements',
          name: 'Announcements',
          component: () => import('./views/messagings/Announcement.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Announcements', active: true }
            ],
            pageTitle: 'Announcements',
            rule: 'teacher'
          }
        },
        {
          path: '/messages',
          name: 'messages',
          component: () => import('./views/chat/Chat.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Messages', active: true }
            ],
            pageTitle: 'Messages',
            rule: 'user',
            no_scroll: true
          }
         
        },
        {
          path: '/customize-dashboard',
          name: 'customize dashboard',
          component: () => import('./views/customize-dashboard/dashboard.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Customize Dashboard', active: true }
            ],
            pageTitle: 'Customize Dashboard',
            rule: 'manager'
         
          }
         
        },
        {
          path: '/messages-log',
          name: 'Messages Log',
          component: () => import('./views/messagings/MessageLogs.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Messages Log', active: true }
            ],
            pageTitle: 'Messages Log',
            rule: 'teacher'
          }
        },
        {
          path: '/activities',
          name: 'Activities',
          component: () => import('./views/activities/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Activities', active: true }
            ],
            pageTitle: 'Activities',
            rule: 'teacher'
          }
        },
        {
          path: '/room-feed',
          name: 'Feed',
          component: () => import('./views/activities/DataRoomFeeds.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Feed', active: true }
            ],
            pageTitle: 'Feed',
            rule: 'teacher'
          }
        },
        {
          path: '/instant_message',
          name: 'Instant Message',
          component: () => import('./views/messagings/InstantMessage.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Instant Message', active: true }
            ],
            pageTitle: 'Instant Message',
            rule: 'teacher'
          }
        },
        {
          path:  i18n.t('menu.teachers.url'),
          name:  i18n.t('menu.teachers.name'),
          component: () => import('@/views/teachers/DataListView.vue'),
          meta: {
            breadcrumb:  i18n.t('menu.teachers.meta.breadcrumb'),
            pageTitle:  i18n.t('menu.teachers.meta.pageTitle'),
            rule:  i18n.t('menu.teachers.meta.rule')
          }
        },
        {
          path: '/managers',
          name: 'managers',
          component: () => import('@/views/managers/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Managers', active: true }
            ],
            pageTitle: 'Managers',
            rule: 'manager'
          }
        },
        {
          path: '/team/:role?',
          name: 'team',
          component: () => import('@/views/team/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Team', active: true }
            ],
            pageTitle: 'Team',
            rule: 'manager'
          }
        },
        {
          path: '/manage-location/:tab?',
          name: 'Manage Location',
          component: () => import('./views/ManageLocation.vue'),
          meta: {
            rule: 'manager'
          }
        },
        // {
        //   path: '/manage-test-location/:tab?',
        //   name: 'Manage Test Location',
        //   component: () => import('./views/ManageTestLocation.vue'),
        //   meta: {
        //     rule: 'manager'
        //   }
        // },
        {
          path: '/team-profile/:team',
          name: 'Team Profile',
          component: () => import('@/views/team/profile.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Team', url: '/team' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Team View',
            rule: 'manager'
          }
        },
        {
          path: i18n.t('route.student_profile.url'),
          name:i18n.t('route.student_profile.name'),
          component: () => import('@/views/students/profile.vue'),
          meta: {
            breadcrumb:i18n.t('route.student_profile.meta.breadcrumb'),
            pageTitle:i18n.t('route.student_profile.meta.pageTitle'),
            rule: i18n.t('route.student_profile.meta.rule')
          }
        },
        {
          path: i18n.t('route.teacher_student_profile.url'),
          name:i18n.t('route.teacher_student_profile.name'),
          component: () => import('@/views/teacher-students/profile.vue'),
          meta: {
            breadcrumb:i18n.t('route.teacher_student_profile.meta.breadcrumb'),
            pageTitle:i18n.t('route.teacher_student_profile.meta.pageTitle'),
            rule: i18n.t('route.teacher_student_profile.meta.rule')
          }
        },
        {
          path: 'user/student/:studentId',
          name: 'User Student Profile',
          component: () => import('@/views/user-students/profile.vue'),
          meta: {
            breadcrumb: [
              {
                'title': 'Home',
                'url': '/'
              },
              {
                'title': 'Students',
                'url': '/user/students'
              },
              {
                'title': 'View',
                'active': true
              }
            ],
            pageTitle: 'Student View',
            rule: 'user'
          }
        },
        {
          path: i18n.t('route.user_profile.url'),
          name: i18n.t('route.user_profile.name'),
          component: () => import('@/views/cam-users/profile.vue'),
          meta: {
            breadcrumb:i18n.t('route.user_profile.meta.breadcrumb'),
            pageTitle: i18n.t('route.user_profile.meta.pageTitle'),
            rule: i18n.t('route.user_profile.meta.rule')
          }
        },
        // {
        //   path: '/student/cameras/:camId',
        //   name: 'app-camera-view',
        //   component: () => import('@/views/students/camprofile.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: 'Students', url:'/students' },
        //       { title: 'View', active: true }
        //     ],
        //     pageTitle: 'Camera View',
        //     rule: 'user'
        //   }
        // },
        {
          path: '/incident/:id',
          name: 'view-incident',
          component: () => import('@/views/incidents/ViewIncident.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Incidents', url:'/incidents' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Incident View',
            rule: 'manager'
          }
        },
        // {
        //   path: '/students/cameras/:camId',
        //   name: 'camera-view',
        //   component: () => import('@/views/user-students/camprofile.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: 'Students', url:'/user/students' },
        //       { title: 'View', active: true }
        //     ],
        //     pageTitle: 'Camera View',
        //     rule: 'user'
        //   }
        // },
        // {
        //   path: i18n.t('route.user_camera.url'),
        //   name:i18n.t('route.user_camera.name'),
        //   component: () => import('@/views/user-students/camprofile.vue'),
        //   meta: {
        //     breadcrumb:i18n.t('route.user_camera.meta.breadcrumb'),
        //     pageTitle:i18n.t('route.user_camera.meta.pageTitle'),
        //     rule: i18n.t('route.user_camera.meta.rule')
        //   }
        // },
        // {
        //   path: '/students/cameras/:camId',
        //   name: 'camera-view',
        //   component: () => import('@/views/user-students/camprofile.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: 'Students', url:'/user/students' },
        //       { title: 'View', active: true }
        //     ],
        //     pageTitle: 'Camera View',
        //     rule: 'user'
        //   }
        // },

        {
          path: i18n.t('menu.admins.url'),
          name: i18n.t('menu.admins.name'),
          component: () => import('@/views/admins/DataListView.vue'),
          meta: {
            breadcrumb: i18n.t('menu.admins.meta.breadcrumb'),
            pageTitle: i18n.t('menu.admins.meta.pageTitle'),
            rule: i18n.t('menu.admins.meta.rule')
          }
        },
        {
          path: i18n.t('menu.users_profile.url'),
          name: i18n.t('menu.users_profile.name'),
          component: () => import('@/views/cam-users/ViewUserProfile.vue'),
          meta: {
            breadcrumb:i18n.t('menu.users_profile.meta.breadcrumb'),
            pageTitle: i18n.t('menu.users_profile.meta.pageTitle'),
            rule: i18n.t('menu.users_profile.meta.rule')
          }
        },
        {
          path: i18n.t('menu.user_student_cameras.url'),
          name:i18n.t('menu.user_student_cameras.name'),
          component: () => import('@/views/user-students/DataCamList.vue'),
          meta: {
            // breadcrumb:i18n.t('menu.user_student_cameras.meta.breadcrumb'),
            pageTitle:i18n.t('menu.user_student_cameras.meta.pageTitle'),
            rule: i18n.t('menu.user_student_cameras.meta.rule')
          }
        },

        {
          path: '/dailylogins',
          name: 'Daily Login',
          component: () => import('./views/reports/DailyLogin.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Daily Camera Logins', active: true }
            ],
            pageTitle: 'Daily Camera Logins',
            rule: 'manager'
          }
        },
        {
          path: '/dailywatchtime',
          name: 'Daily Watch Time',
          component: () => import('./views/reports/DailyWatch.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Daily Watch Time', active: true }
            ],
            pageTitle: 'Daily Watch Time',
            rule: 'manager'
          }
        },
        {
          path: '/camera-being-watched',
          name: 'Camera Being Watched',
          component: () => import('./views/reports/CameraBeingWatched.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Cameras Being Watched', active: true }
            ],
            pageTitle: 'Cameras Being Watched',
            rule: 'manager'
          }
        },
        {
          path: '/online-user-report',
          name: 'Online Users',
          component: () => import('./views/reports/OnlineUserReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Online Users', active: true }
            ],
            pageTitle: 'Online Users',
            rule: 'manager'
          }
        },
        {
          path: '/log-report',
          name: 'Log Report',
          component: () => import('./views/reports/LogReportView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Log Report', active: true }
            ],
            pageTitle: 'Log Report',
            rule: 'manager'
          }
        },
        {
          path: '/activity-report',
          name: 'Activity Report',
          component: () => import('./views/reports/ActivityReportView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Activity Report', active: true }
            ],
            pageTitle: 'Activity Report',
            rule: 'teacher'
          }
        },
        {
          path: '/unsubscribed-emails',
          name: 'Unsubscribed Emails',
          component: () => import('./views/reports/UnsubscribedEmailView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Unsubscribed Emails', active: true }
            ],
            pageTitle: 'Unsubscribed Emails',
            rule: 'manager'
          }
        },
        {
          path: '/unsubscribed-sms',
          name: 'Unsubscribed SMS',
          component: () => import('./views/reports/UnsubscribedSMSView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Unsubscribed SMS', active: true }
            ],
            pageTitle: 'Unsubscribed SMS',
            rule: 'manager'
          }
        },
        {
          path: '/sms-response',
          name: 'SMS Responses',
          component: () => import('./views/reports/SMSResponses.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'SMS Responses', active: true }
            ],
            pageTitle: 'SMS Responses',
            rule: 'manager'
          }
        },
        {
          path: '/newsletters',
          name: 'Newsletters',
          component: () => import('@/views/newsletters/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Newsletters', active: true }
            ],
            pageTitle: 'Newsletters',
            rule: 'manager'
          }
        },
        {
          path: '/newsletters/:tempId',
          name: 'newsletters-temp',
          component: () => import('@/views/newsletters/template1.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Newsletters', url:'/newsletters' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Newsletters',
            rule: 'manager'
          }
        },
        {
          path: '/newsletter/new',
          name: 'new-newsletter',
          component: () => import('@/views/newsletters/NewTemplate.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Newsletters', url:'/newsletters' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Newsletters',
            rule: 'manager'
          }
        },
        {
          path: '/templates',
          name: 'Templates',
          component: () => import('@/views/newsletters/DataListTemp.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Newsletters Templates', active: true }
            ],
            pageTitle: 'Newsletters Templates',
            rule: 'admin'
          }
        },
        {
          path: '/newsletters/:is_temp/:tempId',
          name: 'newsletters-templates',
          component: () => import('@/views/newsletters/template1.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Newsletters Templates', url:'/templates' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Newsletters Templates',
            rule: 'admin'
          }
        },
        {
          path: '/newsletter/:is_temp/new',
          name: 'new-newsletter-template',
          component: () => import('@/views/newsletters/NewTemplate.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Newsletters Templates', url:'/templates' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Newsletters Templates',
            rule: 'admin'
          }
        },
        {
          path: '/permissions',
          name: 'permissions',
          component: () => import('@/views/permissions/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Permissions Management', url:'/permissions', active: true }
              // { title: 'View', active: true }
            ],
            pageTitle: 'Permissions Management',
            rule: 'kvsupport'
          }
        },
        {
          path: '/navigation',
          name: 'navigation',
          component: () => import('@/views/permissions/DataListNavigations.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Navigation Management', url:'/navigation', active: true }
              // { title: 'View', active: true }
            ],
            pageTitle: 'Navigation Management',
            rule: 'kvsupport'
          }
        },
        {
          path: '/streamings',
          name: 'streamings',
          component: () => import('@/views/streamings/DataListListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Streaming Servers', url:'/streamings', active: true }
              // { title: 'View', active: true }
            ],
            pageTitle: 'Streaming Servers',
            rule: 'admin'
          }
        },
        {
          path: '/user/students/check-in-or-out',
          name: 'Check In/Out',
          component: () => import('./views/user-students/DataCheckInOut.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Check In/Out', active: true }
            ],
            pageTitle: 'Check In/Out',
            rule: 'user'
          }
        },
        {
          path: '/student-activity/check-in-or-out',
          name: 'User Check In/Out',
          component: () => import('./views/cam-users/DataCheckInOut.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Check In/Out', active: true }
            ],
            pageTitle: 'Check In/Out',
            rule: 'manager'
          }
        },
        {
          path: '/teacher/students/check-in-or-out',
          name: 'Teacher Check In/Out',
          component: () => import('./views/cam-users/DataCheckInOut.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Check In/Out', active: true }
            ],
            pageTitle: 'Check In/Out',
            rule: 'teacher'
          }
        },
        {
          path: '/room-ratio',
          name: 'room-ratio',
          component: () => import('@/views/room-ratio/RoomRatioData.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Room Ratio', active: true }
            ],
            pageTitle: 'Room Ratio',
            rule: 'manager'
          } 
        },
        // {
        //   path: '/attendanc2',
        //   name: 'attendance',
        //   component: () => import('@/views/attendance/DataAttendance.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: 'Attendance KIOSK', active: true }
        //     ],
        //     pageTitle: 'Attendance KIOSK',
        //     rule: 'teacher'
        //   }
        // },
        {
          path: '/attendance',
          name: 'attendance',
          component: () => import('@/views/attendance/AttendanceTabs.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Attendance KIOSK', active: true }
            ],
            pageTitle: 'Attendance KIOSK',
            rule: 'teacher'
          },
          children: [
            {
              path: 'students',
              name: 'student-attendance',
              component: () => import('@/views/attendance/StudentAttendanceData.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Attendance KIOSK', active: true }
                ],
                pageTitle: 'Attendance KIOSK',
                rule: 'teacher',
                parent:'attendance'
              }
            },
            {
              path: 'staff',
              name: 'staff-attendance',
              component: () => import('@/views/attendance/StaffAttendanceData.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Attendance KIOSK', active: true }
                ],
                pageTitle: 'Attendance KIOSK',
                rule: 'teacher',
                parent:'attendance'
              }
            },
            {
              path: 'reports',
              name: 'attendance-reports',
              component: () => import('@/views/attendance/AttendanceReports.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Attendance KIOSK', active: true }
                ],
                pageTitle: 'Attendance KIOSK',
                rule: 'teacher',
                parent:'attendance'
              }
            },
            {
              path: 'health-screen',
              name: 'attendance-health-screen',
              component: () => import('@/views/attendance/HealthScreen.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Attendance KIOSK', active: true }
                ],
                pageTitle: 'Attendance KIOSK',
                rule: 'teacher',
                parent:'attendance'
              }
            },
            {
              path: 'kiosk',
              name: 'attendance-kiosk',
              component: () => import('@/views/attendance/AttendanceKiosk.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Attendance KIOSK', active: true }
                ],
                pageTitle: 'Attendance KIOSK',
                rule: 'teacher',
                parent:'attendance'
              }
            } 
    
          ] 
        },
        {
          path: '/calendar',
          name: 'calendar',
          component: () => import('@/views/calendar/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Calendar', active: true }
            ],
            pageTitle: 'Calendar',
            rule: 'teacher'
          } 
        },
        {
          path: '/food-menu',
          name: 'food-menu',
          component: () => import('@/views/food-menu/foodMenu.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Food Menu', active: true }
            ],
            pageTitle: 'Food Menu',
            rule: 'teacher'
          } 
        },
        {
          path: '/student-schedules',
          name: 'Student Schedules',
          component: () => import('@/views/schedule-module/DataListListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Schedules', active: true }
            ],
            pageTitle: 'Schedules',
            rule: 'manager'
          } 
        },
        {
          path: '/attendance-summary',
          name: 'Attendance Summary',
          component: () => import('@/views/TimeClockReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Attendance Summary', active: true }
            ],
            pageTitle: 'Attendance Summary',
            rule: 'teacher'
          } 
        },
        {
          path: '/staff-hours',
          name: 'Staff Hours',
          component: () => import('@/views/reports/StaffHoursReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Staff Hours', active: true }
            ],
            pageTitle: 'Staff Hours',
            rule: 'teacher'
          } 
        },
        {
          path: '/student-daily-hours',
          name: 'Daily Student Attendance',
          component: () => import('@/views/reports/StudentDailyHoursReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Daily Student Attendance', active: true }
            ],
            pageTitle: 'Daily Student Attendance',
            rule: 'teacher'
          } 
        },
        {
          path: '/student-hours',
          name: 'Student Hours',
          component: () => import('@/views/reports/StudentHoursReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Student Hours', active: true }
            ],
            pageTitle: 'Student Hours',
            rule: 'teacher'
          } 
        },
        {
          path: 'student-attendance-report',
          name: 'Student Attendance Report',
          component: () => import('@/views/reports/StudentAttendanceReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Student Attendance Report', active: true }
            ],
            pageTitle: 'Student Attendance Report',
            rule: 'teacher'
          } 
        },
        {
          path: '/forms',
          name: 'forms',
          component: () => import('@/views/forms/DataListView.vue'),

          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Forms', active: true }
            ],
            pageTitle: 'Forms',
            rule: 'teacher'
          }
        },
        {
          path: '/shared/forms',
          name: 'forms',
          component: () => import('@/views/forms/StaffFormsList.vue'),

          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Forms', active: true }
            ],
            pageTitle: 'Forms',
            rule: 'teacher'
          }
        },
        {
          path: '/user/students/documents',
          name: 'User Documents',
          component: () => import('@/views/documents/UserDocumentList.vue'),

          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Documents', active: true }
            ],
            pageTitle: 'Documents',
            rule: 'user'
          }
        },
        {
          path: '/documents',
          name: 'Documents',
          component: () => import('@/views/documents/DataListView.vue'),

          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Documents', active: true }
            ],
            pageTitle: 'Documents',
            rule: 'teacher'
          }
        },
     
        
        {
          path: '/document/:documentId',
          name: 'Document View',
          component: () => import('@/views/documents/FileDetailsView.vue'),

          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Document', active: true }
            ],
            pageTitle: 'Document',
            rule: 'teacher'
          }
        },
        {
          path: '/user/students/:studentId/files',
          name: 'User files',
          component: () => import('@/views/forms/StudentFormList.vue'),
          meta: {
            breadcrumb: [
              {
                'title': 'Home',
                'url': '/'
              },
              {
                'title': 'Files',
                'url': '/user/students/files'
              },
              {
                'title': 'View',
                'active': true
              }
            ],
            pageTitle: 'Forms & Requests',
            rule: 'user'
          }
        },
        {
          path: '/user/students/files',
          name: 'files',
          component: () => import('@/views/pages/UserStudentSharedForm.vue'),

          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Files', active: true }
            ],
            pageTitle: 'Files',
            rule: 'user'
          }
        },
        {
          path: 'report-balance',
          name: 'Balance Report',
          component: () => import('@/views/billing/StudentBalanceReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Student Balance Report', active: true }
            ],
            pageTitle: ' Student Balance Report',
            rule: 'admin'
          } 
        },
        {
          path: 'report-transactions',
          name: 'Transactions Report',
          component: () => import('@/views/billing/StudentTransactionReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Transactions Report', active: true }
            ],
            pageTitle: 'Transactions Report',
            rule: 'admin'
          } 
        },
        {
          path: 'report-invoices',
          name: 'Invoices Report',
          component: () => import('@/views/billing/StudentInvoiceReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Invoices Report', active: true }
            ],
            pageTitle: 'Invoices Report',
            rule: 'admin'
          } 
        },
        {
          path: 'report-payments',
          name: 'Payments & Credits Report',
          component: () => import('@/views/billing/StudentPaymentReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Payments & Credits Report', active: true }
            ],
            pageTitle: 'Payments & Credits Report',
            rule: 'admin'
          } 
        },
        {
          path: 'report-billing-summary',
          name: 'Billing Summary Report', 
          component: () => import('@/views/billing/BillingSummaryReport.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Billing Summary Report', active: true }
            ],
            pageTitle: 'Billing Summary Report',
            rule: 'admin'
          } 
        },
        {
          path: '/relationships',
          name: 'Relationships',
          component: () => import('./views/relationships/DataListListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Relationships Management', active: true }
            ],
            pageTitle: 'Relationships Management',
            rule: 'manager'
          }
        },
        {
          path: '/web-servers',
          name: 'web-servers',
          component: () => import('@/views/web-servers/DataListListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Web Servers', url:'/web-servers', active: true }
              // { title: 'View', active: true }
            ],
            pageTitle: 'Web Servers',
            rule: 'admin'
          }
        },
        {
          path: '/immunizations',
          name: 'immunizations',
          component: () => import('@/views/immunizations/DataListListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Immunizations', active: true }
            ],
            pageTitle: 'Immunizations',
            rule: 'kvsupport'
          } 
        },
        
        {
          path: '/blogs',
          name: 'blogs',
          component: () => import('@/views/blogs/DataListListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Blog', active: true }
            ],
            pageTitle: 'Blog',
            rule: 'blog'
          } 
        },
        {
          path: '/submissions',
          name: 'Submissions',
          component: () => import('@/views/suforms/DataListListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Submissions', active: true }
            ],
            pageTitle: 'Submissions',
            rule: 'manager'
          } 
        },
        {
          path: 'billing',
          name: 'billing',
          component: () => import('@/views/billing/BillingTabs.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Billing', active: true }
            ],
            pageTitle: 'Billing',
            rule: 'admin'
          },
          children: [
            {
              path: 'overview',
              name: 'billing-overview',
              component: () => import('@/views/billing/DataBillingOverview.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent:'billing'
              } 
            },
            {
              path: 'unpaid',
              name: 'billing-unpaid',
              component: () => import('@/views/billing/DataListListView.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent:'billing'
              } 
            },
            {
              path: 'payments',
              name: 'billing-payments',
              component: () => import('@/views/billing/DataListPayments.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent:'billing'
              } 
            },
            {
              path: 'students',
              name: 'billing-students',
              component: () => import('@/views/billing/StudentOverviewList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent:'billing'
              } 
            },
            {
              path: 'student-plans',
              name: 'billing-student-plans',
              component: () => import('@/views/billing/DataListPlanView.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent:'billing'
              } 
            },
            {
              path: 'billing-reports',
              name: 'billing-reports',
              component: () => import('@/views/billing/ReportsList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent:'billing'
              } 
            },
            {
              path: 'manage-presets',
              name: 'billing-manager-presets',
              component: () => import('@/views/billing/ManagePresetList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent:'billing'
              } 
            },
            {
              path: 'variable-charges',
              name: 'billing-variable-charges',
              component: () => import('@/views/billing/VariableCharges.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent:'billing'
              } 
            },
            {
              path: 'subsidies',
              name: 'billing-subsidies',
              component: () => import('@/views/billing/agency/DataSubsidiesList.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', active: true }
                ],
                pageTitle: 'Billing',
                rule: 'admin',
                parent:'billing'
              } 
            }
          ] 
        },

       
        // {
        //   path: '/billing-plan',
        //   name: 'billing-plan',
        //   component: () => import('@/views/billing/DataListPlanView.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: 'Student Billing Plans', active: true }
        //     ],
        //     pageTitle: 'Student Billing Plans',
        //     rule: 'admin'
        //   } 
        // },
        {
          path: '/home',
          name: 'user-dashboard',
          component: () => import('@/views/UserDashboard.vue'),
          meta: {
            rule: 'user'
            // pageTitle: 'Home' 
          }
        },
        {
          path: '/dashboard',
          name: 'teacher-dashboard',
          component: () => import('@/views/Home.vue'),
          meta: {
            rule: 'teacher'
            // pageTitle: 'Home' 
          }
        },
        {
          path: '/user/students/billing',
          name: 'user-billing',
          component: () => import('@/views/billing/UserBillingView.vue'),
          meta: {
            rule: 'user',
            pageTitle: 'Payments' 
          }
     
        },
        {
          path: '/files/student/:studentId/form/:formId/submission',
          name: 'Form Submission',
          component: () => import('@/views/pages/FormSubmissionPage.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Form Submission', active: true }
            ],
            pageTitle: 'Form Submission',
            rule: 'user'
          }
        },
        {
          path: '/files/student/:studentId/form/:formId/document/submission',
          name: 'User Form Submission',
          component: () => import('@/views/pages/PdfFormSubmissionPage.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Form Submission', active: true }
            ],
            pageTitle: 'Form Submission',
            rule: 'user'
          }
        },
        {
          path: '/files/form/:formId/submission',
          name: 'User Form Submission',
          component: () => import('@/views/pages/PdfFormStaffSubmission.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Form Submission', active: true }
            ],
            pageTitle: 'Form Submission',
            rule: 'teacher'
          }
        },
        {
          path: '/learning_activities',
          name: 'learning_activities',
          component: () => import('@/views/learning/ViewLearning.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Learning Activities', active: true }
            ],
            pageTitle: 'Learning Activities',
            rule: 'teacher'
          }
        },
        {
          path: '/lesson_plan',
          name: 'lesson_plan',
          component: () => import('@/views/learning/DataLessonPlan.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Lesson Plans', active: true }
            ],
            pageTitle: 'Lesson Plans',
            rule: 'teacher'
          }
        },
        {
          path: '/room_plans',
          name: 'room_plans',
          component: () => import('@/views/learning/LearningRoomPlan.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Room Plans', active: true }
            ],
            pageTitle: 'Room Plans',
            rule: 'teacher'
          }
        },
        {
          path: '/learning_frameworks',
          name: 'Frameworks',
          component: () => import('./views/Settings/Frameworks'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Learning Frameworks', active: true }
            ],
            pageTitle: 'Learning Frameworks',
            rule: 'teacher'
          }
        },
        {
          path: '/learning_skills',
          name: 'Learning Skills',
          component: () => import('./views/learning/LearningSkills'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Learning Skills', active: true }
            ],
            pageTitle: 'Learning Skills',
            rule: 'teacher'
          }
        },
        {
          path: '/portfolios',
          name: 'portfolios',
          component: () => import('@/views/learning/Portfolio.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Portfolios', active: true }
            ],
            pageTitle: 'Portfolios',
            rule: 'teacher'
          }
        },
        {
          path: '/portfolio_preview/:portfolioId',
          name: 'portfolio_preview',
          component: () => import('@/views/learning/PortfolioPreview.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Portfolio Preview', active: true }
            ],
            pageTitle: 'Portfolio Preview',
            rule: 'user'
          }
        },
        {
          path: 'form/:formId/edit',
          name: 'Form',
          component: () => import('@/views/pages/FormViewPage.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Edit Form', active: true }
            ],
            pageTitle: 'Edit Form',
            rule: 'user'
          }
        },
        {
          path: 'form/:formId',
          name: 'Shared Form',
          component: () => import('@/views/forms/SharedForms.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Parent Submissions', active: true }
            ],
            pageTitle: 'Parent Submissions',
            rule: 'user'
          }
        },
        {
          path: 'form/:formId/entries',
          name: 'Entries',
          component: () => import('@/views/forms/EntriesFormBuilder.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Form Entries', active: true }
            ],
            pageTitle: 'Parent Submissions',
            rule: 'user'
          }
        },
        {
          path: 'form/:formId/:entryId',
          name: 'View Entry',
          component: () => import('@/views/forms/EntryView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Form Entries', active: true }
            ],
            pageTitle: 'Entry View',
            rule: 'user'
          }
        },
        {
          path: 'students/:studentId/form/review/:formId',
          name: 'Review',
          component: () => import('@/views/forms/ReviewSubmissions.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Review Submission', active: true }
            ],
            pageTitle: 'Review Submission',
            rule: 'user'
          }
        },
        {
          path: 'form/:formId/share',
          name: 'Share Parent Form',
          component: () => import('@/views/forms/ShareParents.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Form', active: true }
            ],
            pageTitle: 'Form',
            rule: 'user'
          }
        },
        // {
        //   path: '/testing2',
        //   name: 'testing2',
        //   component: () => import('@/views/Testing2.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: 'Location', active: true }
        //     ],
        //     pageTitle: 'Location',
        //     rule: 'admin'
        //   }
        // },
        {
          path: '/billing/student/:studentId',
          name: 'billing-student',
          component: () => import('@/views/billing/StudentView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Billing', url: '/billing/overview' },
              { title: 'Student Account', active: true }
            ],
            pageTitle: 'Student Account',
            rule: 'manager'
          },
          children: [
            {
              path: '/billing/student/overview/:studentId',
              name: 'student-overview',
              component: () => import('@/views/billing/StudentBillingOverview.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Student Account', active: true }
                ],
                pageTitle: 'Student Account',
                rule: 'manager'
              }
             
            },
            {
              path: '/billing/student/open-invoices/:studentId',
              name: 'student-open-invoices',
              component: () => import('@/views/billing/StudentOpenInvoices.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Student Account', active: true }
                ],
                pageTitle: 'Student Account',
                rule: 'manager'
              }
             
            },
            {
              path: '/billing/student/available-credits/:studentId',
              name: 'student-available-credits',
              component: () => import('@/views/billing/StudentCredits.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Student Account', active: true }
                ],
                pageTitle: 'Student Account',
                rule: 'manager'
              }
            },
            {
              path: '/billing/student/invoices/:studentId',
              name: 'student-invoices',
              component: () => import('@/views/billing/StudentInvoices.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Student Account', active: true }
                ],
                pageTitle: 'Student Account',
                rule: 'manager'
              }
            },
            {
              path: '/billing/student/payments/:studentId',
              name: 'student-payments',
              component: () => import('@/views/billing/StudentPayments.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Student Account', active: true }
                ],
                pageTitle: 'Student Account',
                rule: 'manager'
              }
            },
            {
              path: '/billing/student/upcoming-invoices/:studentId',
              name: 'student-upcoming-invoices',
              component: () => import('@/views/billing/StudentUpcomingInvoices.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Student Account', active: true }
                ],
                pageTitle: 'Student Account',
                rule: 'manager'
              }
            },
            {
              path: '/billing/student/account-detail/:studentId',
              name: 'student-account-detail',
              component: () => import('@/views/billing/StudentAccountDetails.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Student Account', active: true }
                ],
                pageTitle: 'Student Account',
                rule: 'manager'
              }
            },
            {
              path: '/billing/student/plans-detail/:studentId',
              name: 'student-plans-detail',
              component: () => import('@/views/billing/StudentPlans.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Student Account', active: true }
                ],
                pageTitle: 'Student Account',
                rule: 'manager'
              }
            },
            {
              path: '/billing/student/payers-detail/:studentId',
              name: 'student-payers-detail',
              component: () => import('@/views/billing/StudentPayers.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Student Account', active: true }
                ],
                pageTitle: 'Student Account',
                rule: 'manager'
              }
            }
          ] 
        },
        {
          path: '/billing/agency/:agencyId',
          name: 'billing-agency',
          component: () => import('@/views/billing/agency/AgencyView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Billing', url: '/billing/overview' },
              { title: 'Agency Account', active: true }
            ],
            pageTitle: 'Agency Account',
            rule: 'manager'
          }, 
          children: [
            {
              path: '/billing/agency/overview/:agencyId',
              name: 'agency-overview',
              component: () => import('@/views/billing/agency/AgencyOverview.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Agency Account', active: true }
                ],
                pageTitle: 'Agency Account',
                rule: 'manager'
              }
             
            },
            {
              path: '/billing/agency/invoices/:agencyId',
              name: 'agency-invoices',
              component: () => import('@/views/billing/agency/AgencyInvoices.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Agency Account', active: true }
                ],
                pageTitle: 'Agency Account',
                rule: 'manager'
              }
             
            },
            {
              path: '/billing/agency/payments/:agencyId',
              name: 'agency-payments',
              component: () => import('@/views/billing/agency/AgencyPayments.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Agency Account', active: true }
                ],
                pageTitle: 'Agency Account',
                rule: 'manager'
              }
             
            },
            {
              path: '/billing/agency/students/:agencyId',
              name: 'agency-students',
              component: () => import('@/views/billing/agency/AgencyStudents.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Agency Account', active: true }
                ],
                pageTitle: 'Agency Account',
                rule: 'manager'
              }
             
            },
            {
              path: '/billing/agency/info/:agencyId',
              name: 'agency-info',
              component: () => import('@/views/billing/agency/AgencyInfo.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Agency Account', active: true }
                ],
                pageTitle: 'Agency Account',
                rule: 'manager'
              }
             
            },
            {
              path: '/billing/agency/upcoming-invoices/:agencyId',
              name: 'agency-upcoming-invoices',
              component: () => import('@/views/billing/agency/UpcommingInvoices.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: 'Billing', url: '/billing/overview' },
                  { title: 'Agency Account', active: true }
                ],
                pageTitle: 'Agency Account',
                rule: 'manager'
              }
             
            }
          ]
        },
        {
          path: '/centers-plans',
          name: 'Center Billing Plans',
          component: () => import('@/views/aws-centers/billing/plans/BillingPlans.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Billing Plans', active: true }
            ],
            pageTitle: 'Billing Plans',
            rule: 'admin'
          }
        },
        {
          path: '/centers-invoices',
          name: 'Center Invoices',
          component: () => import('@/views/aws-centers/invoices/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Invoices', active: true }
            ],
            pageTitle: 'Invoices',
            rule: 'admin'
          }
        },
        {
          path: '/centers-payments',
          name: 'Center Payments',
          component: () => import('@/views/aws-centers/payments/DataListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Payments', active: true }
            ],
            pageTitle: 'Payments',
            rule: 'admin'
          }
        },
        // {
        //   path: 'kidsvision-plan',
        //   name: 'kidsvision-plan',
        //   component: () => import('@/views/aws-centers/Subscription.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: 'My kidsVision Plan', active: true }
        //     ],
        //     pageTitle: 'My kidsVision Plan',
        //     rule: 'admin'
        //   }
        // },
        // {
        //   path: 'test-player',
        //   name: 'test-player',
        //   component: () => import('@/views/TestPlayer.vue'),
        //   meta: {
        //     rule: 'admin'
        //   }
        // },
        {
          path: '/grapesjs/:page?',
          name: 'grapes-js',
          component: () => import('@/views/grapesjs/grapes.vue'),
          meta: {
            pageTitle: ' ',
            rule: 'admin'
            // breadcrumb: [
            //   {
            //     text: 'Second Page',
            //     active: true,
            //   },
            // ],
          }
        },
        {
          path: '/sites',
          name: 'sites',
          component: () => import('@/views/grapesjs/sites.vue'),
          meta: {
            rule: 'admin',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Sites', url:'/sites', active: true }
            ],
            pageTitle: 'Sites'
          }
        },
        {
          path: '/site/:siteName/:sitePage',
          name:'site',
          component: () => import('@/views/grapesjs/site.vue'),
          meta: {
            // breadcrumb:[
            //   {
            //     'title': 'Home',
            //     'url': '/'
            //   },
            //   {
            //     'title': 'Locations',
            //     'url': '/locations'
            //   },
            //   {
            //     'title': 'View',
            //     'active': true
            //   }
            // ],
            pageTitle:' ',
            rule: 'admin'
          }
        },
        {
          path: '/site-details/:siteName',
          name:'site-details',
          component: () => import('@/views/grapesjs/site-details.vue'),
          meta: {
            breadcrumb:[
              {
                'title': 'Home',
                'url': '/'
              },
              {
                'title': 'Websites Builder',
                'url': '/sites'
              },
              {
                'title': 'Control Panel',
                'active': true
              }
            ],
            pageTitle:'Control Panel',
            rule: 'admin'
          }
        },
        {
          path: '/food/:siteName',
          name:'food',
          component: () => import('@/views/grapesjs/foodMenu/foodMenu.vue'),
          meta: {
            // breadcrumb:[
            //   {
            //     'title': 'Home',
            //     'url': '/'
            //   },
            //   {
            //     'title': 'Websites Builder',
            //     'url': '/sites'
            //   },
            //   {
            //     'title': localStorage.getItem('site-Name'),
            //     'url': '/site-details/'+localStorage.getItem('site-Id')
            //   },
            //   {
            //     'title': 'View Menu',
            //     'active': true
            //   }
            // ],
            // pageTitle:'View Menu',
            rule: 'admin'
          }
        },

        {
          path: '/events/:siteName',
          name:'events',
          component: () => import('@/views/grapesjs/events/events.vue'),
          meta: {
            // breadcrumb:[
            //   {
            //     'title': 'Home',
            //     'url': '/'
            //   },
            //   {
            //     'title': 'Websites Builder',
            //     'url': '/sites'
            //   },
            //   {
            //     'title': localStorage.getItem('site-Name'),
            //     'url': '/site-details/'+localStorage.getItem('site-Id')
            //   },
            //   {
            //     'title': 'View Events',
            //     'active': true
            //   }
            // ],
            // pageTitle:'View Events',
            rule: 'admin'
          }
        },
        {
          path: '/staff/:siteName',
          name:'staff events',
          component: () => import('@/views/grapesjs/staff/DataListListView.vue'),
          meta: {
            // breadcrumb:[
            //   {
            //     'title': 'Home',
            //     'url': '/'
            //   },
            //   {
            //     'title': 'Websites Builder',
            //     'url': '/sites'
            //   },
            //   {
            //     'title': localStorage.getItem('site-Name'),
            //     'url': '/site-details/'+localStorage.getItem('site-Id')
            //   },
            //   {
            //     'title': 'View Staff',
            //     'active': true
            //   }
            // ],
            // pageTitle:'View Staff',
            rule: 'admin'
          }
        },
        {
          path: '/program/:siteName',
          name:'program',
          component: () => import('@/views/grapesjs/program/DataListListView.vue'),
          meta: {
            // breadcrumb:[
            //   {
            //     'title': 'Home',
            //     'url': '/'
            //   },
            //   {
            //     'title': 'Websites Builder',
            //     'url': '/sites'
            //   },
            //   {
            //     'title': localStorage.getItem('site-Name'),
            //     'url': '/site-details/'+localStorage.getItem('site-Id')
            //   },
            //   {
            //     'title': 'View Programs',
            //     'active': true
            //   }
            // ],
            // pageTitle:'View Programs',
            rule: 'admin'
          }
        },
        {
          path: '/news/:siteName',
          name:'news',
          component: () => import('@/views/grapesjs/news/DataListListView.vue'),
          meta: {
            // breadcrumb:[
            //   {
            //     'title': 'Home',
            //     'url': '/'
            //   },
            //   {
            //     'title': 'Websites Builder',
            //     'url': '/sites'
            //   },
            //   {
            //     'title': localStorage.getItem('site-Name'),
            //     'url': '/site-details/'+localStorage.getItem('site-Id')
            //   },
            //   {
            //     'title': 'View News',
            //     'active': true
            //   }
            // ],
            // pageTitle:'View News',
            rule: 'admin'
          }
        },
        {
          path: '/testimonials/:siteName',
          name:'Testimonials',
          component: () => import('@/views/grapesjs/testimonials/DataListListView.vue'),
          meta: {
            // breadcrumb:[
            //   {
            //     'title': 'Home',
            //     'url': '/'
            //   },
            //   {
            //     'title': 'Websites Builder',
            //     'url': '/sites'
            //   },
            //   {
            //     'title': localStorage.getItem('site-Name'),
            //     'url': '/site-details/'+localStorage.getItem('site-Id')
            //   },
            //   {
            //     'title': 'View Testimonials',
            //     'active': true
            //   }
            // ],
            // pageTitle:'View Testimonials',
            rule: 'admin'
          }
        },
        {
          path: '/procare',
          name: 'procare',
          component: () => import('./views/Settings/ProCare'),
          meta: {
            pageTitle: ' ',
            rule: 'admin'
            // breadcrumb: [
            //   {
            //     text: 'Second Page',
            //     active: true,
            //   },
            // ],
          }
        },
        {
          path: '/draft',
          name: 'draft-grapes-js',
          component: () => import('@/views/grapesjs/draft.vue'),
          meta: {
            pageTitle: 'Test',
            rule: 'admin'
            // breadcrumb: [
            //   {
            //     text: 'Second Page',
            //     active: true,
            //   },
            // ],
          }
        },
        {
          path: '/confirm',
          name: 'confirm',
          component: () => import('@/views/cam-users/ConfirmAction.vue'),
          meta: {
            rule: 'manager'
          }
        },
        {
          path: '/files-manager/:siteName',
          name:'files-manager',
          component: () => import('@/views/grapesjs/files-manager/DataListView.vue'),
          meta: {
            // breadcrumb:[
            //   {
            //     'title': 'Home',
            //     'url': '/'
            //   },
            //   {
            //     'title': 'Websites Builder',
            //     'url': '/sites'
            //   },
            //   {
            //     'title': localStorage.getItem('site-Name'),
            //     'url': '/site-details/'+localStorage.getItem('site-Id')
            //   },
            //   {
            //     'title': 'File Manager',
            //     'active': true
            //   }
            // ],
            // pageTitle:'File Manager',
            rule: 'admin'
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: 'login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'register/:code?',
          name: 'page-register',
          component: () => import('@/views/pages/Register'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'email-confirmation',
          name: 'email-confirmation',
          component: () => import('@/views/pages/EmailConfirmationPage'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'verify-autologin/:token?',
          name: 'verify-autologin',
          component: () => import('@/views/pages/VerifyAutoLogin'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'verify-email/:pin_time?',
          name: 'verify-email',
          component: () => import('@/views/pages/VerifyEmailPage'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'viue/:pin_time',
          name: 'viue',
          component: () => import('@/views/pages/VerifyInvitedUserEmail'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'viup/:pin_time',
          name: 'viup',
          component: () => import('@/views/pages/VerifyInvitedUserPhone'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'password/reset/:token?',
          name: 'reset-password',
          component: () => import('@/views/pages/ResetPassword'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'approve-user/:token',
          name: 'approve-user',
          component: () => import('@/views/pages/ApproveUser'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'forgot-password',
          name: 'forgot-password',
          component: () => import('@/views/pages/ForgotPassword'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'resend-confirmation-email',
          name: 'resend-confirmation-email',
          component: () => import('@/views/pages/ResendTokenEmail'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'unsubscribe/:token?',
          name: 'unsubscribe email',
          component: () => import('@/views/pages/UnsubscribeEmail.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'time-clock-page/:location',
          name: 'Time Clock Screen',
          component: () => import('@/views/pages/TimeclockScreen.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'demo/:action?',
          name: 'Demo',
          component: () => import('@/views/CustomerSignup/requestDemo.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'customer-signup/:action?',
          name: 'Customers Signup',
          component: () => import('@/views/CustomerSignup/customerSignup.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'packages',
          name: 'packages',
          component: () => import('@/views/CustomerSignup/packagesPlan.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'customer-payment',
          name: 'customer-payment',
          component: () => import('@/views/CustomerSignup/paymentScreen.vue'),
          meta: {
            rule: 'guest'
          }
        },
        {
          path: 'customer-center-setup/:token?',
          name: 'customer-center-setup',
          component: () => import('@/views/CustomerSignup/paymentSuccessPage.vue'),
          meta: {
            rule: 'guest'
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
   
})
 

router.beforeEach((to, from, next) => {
  router.app.$nextTick(() => {
    if (from && from.name) {
      router.app.$vs.loading({
        type: 'sound'
      })
    }
    next()
  })
})

router.afterEach(() => {
  router.app.$nextTick(() => {
    // console.log('offAfter')
    router.app.$vs.loading.close()
   
  })
})


export default router